import React from 'react';
import UIStrings from '@/Utils/UIStrings';

interface InterviewConfirmDialogHeaderProps {
    name: string;
}

function InterviewConfirmDialogHeader({ name }: InterviewConfirmDialogHeaderProps): React.JSX.Element {
    return (
        <div className="text-foreground text-xl font-bold">
            <span>{`${UIStrings.InterviewConfirmDialogHeader1} `}</span>
            <span>{`${name}?`}</span>
        </div>
    );
}
export default InterviewConfirmDialogHeader;
